import { AuthSetAuthorizedReducer } from './types';

export const authSetAuthorizedReducer: AuthSetAuthorizedReducer = (
  state,
  action
) => {
  const authData = action.payload;

  return {
    ...state,
    isAuthorized: true,
    isAdmin: Boolean(authData),
  };
};
